import { render } from "./UiGravatar.vue?vue&type=template&id=1b5acee8&ts=true"
import script from "./UiGravatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiGravatar.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiGravatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b5acee8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b5acee8', __exports__)) {
    api.reload('1b5acee8', __exports__)
  }
  
  module.hot.accept("./UiGravatar.vue?vue&type=template&id=1b5acee8&ts=true", () => {
    api.rerender('1b5acee8', render)
  })

}


export default __exports__